module.exports = __webpack_public_path__ + "assets/2534db8cf92dda12283241086993db75.png";